(function () {

  // Postcodes that only get Tue/Thu delivery
  const RESTRICTED_POSTCODES = ["2320", "2321", "2322", "2323", "2327"];

  // Postcodes that get Mon-Fri delivery
  const MON_FRI_POSTCODES = [
    "2278", "2280", "2281", "2282", "2283", "2284", "2285", "2286", "2287",
    "2289", "2290", "2291", "2292", "2293", "2294", "2296", "2297", "2298",
    "2299", "2300", "2302", "2303", "2304", "2305", "2306", "2307", "2308"
  ];

  let currentPostcode = "";
  let observer = null;
  let injected = false;

  function getPostcodeStatus(postcode) {
    const pc = (postcode || "").trim();
    if (!pc || pc.length < 4) return "unknown";
    if (RESTRICTED_POSTCODES.includes(pc)) return "tue-thu";
    if (MON_FRI_POSTCODES.includes(pc)) return "mon-fri";
    return "no-delivery";
  }

  function getDayFromAriaLabel(ariaLabel) {
    if (!ariaLabel) return null;
    return ariaLabel.split(",")[0].trim().toLowerCase();
  }

  function restrictCalendar() {
    const status = getPostcodeStatus(currentPostcode);

    // Restore all hidden days first
    document.querySelectorAll(".buuntoCal-day[data-ddp-hidden]").forEach(el => {
      el.style.visibility = "";
      el.style.pointerEvents = "";
      el.style.opacity = "";
      el.removeAttribute("data-ddp-hidden");
    });

    if (status === "tue-thu") {
      // Hide all available days that aren't Tue or Thu
      document.querySelectorAll(".buuntoCal-day.buuntoCal-available").forEach(el => {
        const label = el.getAttribute("aria-label") || "";
        const day = getDayFromAriaLabel(label);
        if (day && day !== "tuesday" && day !== "thursday") {
          el.style.visibility = "hidden";
          el.style.pointerEvents = "none";
          el.style.opacity = "0";
          el.setAttribute("data-ddp-hidden", "true");
        }
      });
    } else if (status === "mon-fri") {
      // Hide Sat/Sun
      document.querySelectorAll(".buuntoCal-day.buuntoCal-available").forEach(el => {
        const label = el.getAttribute("aria-label") || "";
        const day = getDayFromAriaLabel(label);
        if (day && (day === "saturday" || day === "sunday")) {
          el.style.visibility = "hidden";
          el.style.pointerEvents = "none";
          el.style.opacity = "0";
          el.setAttribute("data-ddp-hidden", "true");
        }
      });
    }
    // no-delivery and unknown: leave calendar as-is (Buunto handles it)
  }

  function injectPostcodeField() {
    if (injected) return;
    const target = document.querySelector(".buunto-date-field");
    if (!target) return;
    injected = true;

    const wrapper = document.createElement("div");
    wrapper.id = "ddp-postcode-wrapper";
    wrapper.innerHTML = `
      <div style="margin-bottom:12px;">
        <label style="display:block; font-size:12px; font-weight:600; margin-bottom:6px; color:#555;">
          Enter your postcode to see available delivery days
        </label>
        <div style="display:flex; align-items:center; gap:10px; flex-wrap:wrap;">
          <input
            type="text"
            id="ddp-postcode"
            placeholder="e.g. 2300"
            maxlength="4"
            style="width:90px; padding:7px 10px; font-size:14px; font-weight:600;
                   border:1.5px solid #ddd; border-radius:6px; outline:none;
                   letter-spacing:0.05em;"
          />
          <span id="ddp-postcode-badge" style="display:none; font-size:11px; font-weight:700;
                padding:3px 9px; border-radius:20px; letter-spacing:0.04em;"></span>
        </div>
        <p id="ddp-postcode-hint" style="font-size:12px; margin:6px 0 0; color:#999; line-height:1.5;"></p>
      </div>
    `;

    target.parentNode.insertBefore(wrapper, target);

    const input = document.getElementById("ddp-postcode");
    const badge = document.getElementById("ddp-postcode-badge");
    const hint = document.getElementById("ddp-postcode-hint");
    const dateField = document.querySelector(".buunto-date-field");

    input.addEventListener("input", (e) => {
      currentPostcode = e.target.value.replace(/\D/g, "").trim();
      updateUI(badge, hint, dateField, currentPostcode);
      restrictCalendar();
    });

    input.addEventListener("focus", () => { input.style.borderColor = "#333"; });
    input.addEventListener("blur", () => { input.style.borderColor = "#ddd"; });

    // Init hint
    hint.textContent = "Your delivery days will update based on your postcode";
  }

  function updateUI(badge, hint, dateField, postcode) {
    const status = getPostcodeStatus(postcode);

    // Show/hide the Buunto date field based on whether we deliver there
    if (dateField) {
      dateField.style.display = status === "no-delivery" ? "none" : "";
    }

    if (!postcode || postcode.length < 4) {
      badge.style.display = "none";
      hint.textContent = "Your delivery days will update based on your postcode";
      hint.style.color = "#999";
      return;
    }

    badge.style.display = "inline-block";

    if (status === "tue-thu") {
      badge.textContent = "Tue & Thu only";
      badge.style.background = "#fff3cd";
      badge.style.color = "#856404";
      badge.style.border = "1px solid #ffc107";
      hint.textContent = "⚡ This postcode receives deliveries on Tuesdays & Thursdays only";
      hint.style.color = "#856404";
    } else if (status === "mon-fri") {
      badge.textContent = "Mon – Fri";
      badge.style.background = "#d1f5e0";
      badge.style.color = "#1a6636";
      badge.style.border = "1px solid #5cb87a";
      hint.textContent = "✓ This postcode is eligible for delivery Monday to Friday";
      hint.style.color = "#1a6636";
    } else {
      badge.textContent = "Not in delivery zone";
      badge.style.background = "#fde8e8";
      badge.style.color = "#9b1c1c";
      badge.style.border = "1px solid #f87171";
      hint.textContent = "Sorry, we don't currently deliver to this postcode. Please contact us if you think this is an error.";
      hint.style.color = "#9b1c1c";
    }
  }

  function observeCalendar() {
    const target = document.querySelector(".buunto-date-field") || document.body;
    if (observer) observer.disconnect();
    observer = new MutationObserver(() => {
      restrictCalendar();
    });
    observer.observe(target, { childList: true, subtree: true });
  }

  function init() {
    const interval = setInterval(() => {
      const dateField = document.querySelector(".buunto-date-field");
      if (dateField) {
        clearInterval(interval);
        injectPostcodeField();
        observeCalendar();
        restrictCalendar();
      }
    }, 300);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Re-init if cart drawer opens dynamically
  document.addEventListener("click", () => {
    setTimeout(() => {
      if (!injected && document.querySelector(".buunto-date-field")) {
        injectPostcodeField();
        observeCalendar();
        restrictCalendar();
      }
    }, 500);
  });

})();